//
// RuleDataItemMap.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import ClosetObject from "../../ClosetObject";
import "../../lib";
import "./AbstractDataItem";

var RuleDataItemMap = createModule("commons::RuleDataItemMap", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        setDataItemForName: [0,7,1],
        getDataItem: [1,7],
    },
    {
        _create: [4],
    },
    ,
]);
export default RuleDataItemMap;
